/** @format */

import React, { Component } from 'react';
//@ts-ignore
import { Image } from 'react-native';
interface props {
  height?: number;
  width?: number;
  uri: string;
  style?: any;
}
interface states {
  source: {
    uri: string;
  };
  width?: number;
  height?: number;
}
export default class FlexImage extends Component<props, states> {
  constructor(props: props) {
    super(props);
    this.state = { source: { uri: this.props.uri }, width: 0, height: 0 };
  }
  componentWillMount() {
    Image.getSize(this.props.uri, (width: number, height: number) => {
      if (this.props.width && !this.props.height) {
        this.setState({ width: this.props.width, height: height * (this.props.width / width) });
      } else if (!this.props.width && this.props.height) {
        this.setState({ width: width * (this.props.height / height), height: this.props.height });
      } else {
        this.setState({ width, height });
      }
    });
  }
  render() {
    return (
      <Image
        source={this.state.source}
        style={{
          ...this.props.style,
          height: this.state.height,
          width: this.state.width,
        }}
      />
    );
  }
}
